const startOfLocalDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** Which recency section a timestamp falls in, by the reader's local calendar day. */
export const getRecencyGroupLabel = (iso: string, now = new Date()): string => {
	const date = new Date(iso);
	if (Number.isNaN(date.getTime())) return 'Earlier';

	const diffDays = Math.round((startOfLocalDay(now).getTime() - startOfLocalDay(date).getTime()) / 86_400_000);

	if (diffDays <= 0) return 'Today';
	if (diffDays === 1) return 'Yesterday';
	if (diffDays < 7) return 'Previous 7 days';
	return 'Earlier';
};

/**
 * Splits a newest-first list into consecutive recency sections. It groups runs rather than
 * buckets, so it relies on that order instead of re-sorting.
 */
export const groupByRecency = <T>(items: T[], getIso: (item: T) => string, now = new Date()) => {
	const groups: Array<{ label: string; items: T[] }> = [];

	for (const item of items) {
		const label = getRecencyGroupLabel(getIso(item), now);
		const currentGroup = groups[groups.length - 1];

		if (currentGroup?.label === label) {
			currentGroup.items.push(item);
		} else {
			groups.push({ label, items: [item] });
		}
	}

	return groups;
};
